import React, { useState } from 'react';
import { connect } from 'react-redux';
import FiltroNetPay from './list-transactions-netpay/components/FiltroNetPay';
import { netPayAction } from '_models/redux/list-transactions-netpay/action';
import { cleanNetPayAction } from '_models/redux/list-transactions-netpay/clean-action';
import Grid from '@mui/material/Grid';
import { Box, Typography } from '@mui/material';
import { PageNetPayHook } from './list-transactions-netpay/hooks/PageNetPayHook';
import DataTable from 'widgets/datagrid/DataTable';
import { detailNetPayAction } from '_models/redux/detail-transactions-netpay/action';
import { cleanDetailNetPayAction } from '_models/redux/detail-transactions-netpay/clean-action';
import { actionReportTransactionsFraud } from '_models/redux/report-transaction-fraud/action';
import { cleanReportTransactionsFraud } from '_models/redux/report-transaction-fraud/clean_action';
import { cleanReportPrepaidChargebackDetails } from '_models/redux/report-transaction-chargeback/clean_action';
import { actionReportTransactionsChargeback } from '_models/redux/report-transaction-chargeback/action';
import NetPayMessageDialog from './components/NetPayMessageDialog';
import NetPayDetailsDialog from './components/NetPayDetailsDialog';
import NetPayFraudDialog from './components/NetPayFraudDialog';

const PageNetPay = ({
  netPayAction,
  netPay,
  cleanNetPayAction,
  cleanDetailNetPayAction,
  detailNetPayAction,
  detailTransactionsNetpay,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  reportTransactionsFraud,
  reportTransactionsChargeback,
  cleanReportPrepaidChargebackDetails,
  actionReportTransactionsChargeback,
  transactionId,
  onClose,
}) => {
  const [hasSearched, setHasSearched] = useState(false);

  const {
    register,
    handleSubmit,
    errors,
    onSubmit,
    handleCleanFilters,
    loading,
    page,
    size,
    pagination,
    mappedRows,
    handleRowClick,
    Columns,
    isDialogOpen,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    openActionFraud,
    setDescriptionTransaction,
    setError,
    error,
    handleConfirm,
    loadingFraudAndChargeback,
    isError,
    handleCloseFraudChargeback,
    setOpenActionFraud,
    handleOpenPopUp,
    setIdReverso,
    setActiveAction,
    setShouldReturnData,
    activeAction,
    shouldReturnData,
    handleSubmitWithFlag,
  } = PageNetPayHook({
    setHasSearched,
    netPayAction,
    cleanNetPayAction,
    netPay,
    cleanDetailNetPayAction,
    detailNetPayAction,
    detailTransactionsNetpay,
    actionReportTransactionsFraud,
    cleanReportTransactionsFraud,
    reportTransactionsFraud,
    reportTransactionsChargeback,
    cleanReportPrepaidChargebackDetails,
    actionReportTransactionsChargeback,
    transactionId,
    onClose,
  });

  return (
    <Box>
      <Grid>
        <h4> Transacciones de NetPay </h4>
      </Grid>
      <Box sx={{ mb: 10 }}>
        <FiltroNetPay
          onSubmit={handleSubmitWithFlag(onSubmit)}
          handleSubmit={handleSubmit}
          errors={errors}
          register={register}
          onCleanFilters={handleCleanFilters}
        />
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </Box>

      <>
        {mappedRows?.length > 0 ? (
          <Box>
            <DataTable
              rows={mappedRows}
              columns={Columns}
              onRowClick={handleRowClick}
              page={page}
              pageSize={size}
              rowCount={pagination?.total_rows ?? 0}
              onPageChange={pagination?.handleChangePage}
              handleChangePageSize={pagination?.handleChangePageSize}
              loading={loading}
            />
          </Box>
        ) : (
          hasSearched && <Typography variant='h6'>No hay registros disponibles</Typography>
        )}
      </>

      <NetPayDetailsDialog
        open={isDialogOpenDetails}
        onClose={handleClose}
        loading={loading}
        detailTransactionsNetpay={detailTransactionsNetpay}
        handleOpenPopUp={handleOpenPopUp}
        setOpenActionFraud={setOpenActionFraud}
        setIdReverso={setIdReverso}
        setActiveAction={setActiveAction}
        setShouldReturnData={setShouldReturnData}
        activeAction={activeAction}
        shouldReturnData={shouldReturnData}
      />

      <NetPayMessageDialog
        open={isDialogOpen}
        onClose={handleClose}
        dialogMessage={dialogMessage}
      />

      <NetPayFraudDialog
        open={openActionFraud}
        onClose={handleCloseFraudChargeback}
        handleConfirm={handleConfirm}
        setDescriptionTransaction={setDescriptionTransaction}
        setError={setError}
        error={error}
        loadingFraudAndChargeback={loadingFraudAndChargeback}
        dialogMessage={dialogMessage}
        isError={isError}
        reportTransactionsFraud={reportTransactionsFraud}
        reportTransactionsChargeback={reportTransactionsChargeback}
      />
    </Box>
  );
};

const mapStateToProps = (state) => ({
  netPay: state?.netPay,
  detailTransactionsNetpay: state?.detailTransactionsNetpay,
  reportTransactionsFraud: state?.reportTransactionsFraud,
  reportTransactionsChargeback: state?.reportTransactionsChargeback,
});

const mapDispatchToProps = {
  cleanNetPayAction,
  netPayAction,
  cleanDetailNetPayAction,
  detailNetPayAction,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  cleanReportPrepaidChargebackDetails,
  actionReportTransactionsChargeback,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageNetPay);
